<div class="bg-white rounded-md shadow-sm border border-gray-100 p-4">
  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center space-x-2">
      <div class="w-8 h-8 bg-blue-100 rounded-md flex items-center justify-center">
        <i class="fas fa-map-marker-alt text-blue-600 text-sm"></i>
      </div>
      <h3 class="text-base font-semibold text-gray-900">MANAGE PROPERTY</h3>
    </div>
  </div>

  <div class="space-y-4">
    <!-- Property Select -->
    <div class="space-y-1">
      <label class="block text-xs font-medium text-gray-700">Select Property</label>
      <app-property-select class="w-full"></app-property-select>
    </div>

    <!-- Action Buttons -->
    <div class="flex flex-col space-y-2">
      <button 
        [routerLink]="['/map','createProperty']" 
        class="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-3 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 flex items-center justify-center space-x-2 text-sm"
      >
        <i class="fas fa-plus text-xs"></i>
        <span>CREATE PROPERTY</span>
      </button>
      
      <button 
        [routerLink]="['/map','editProperty']" 
        class="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-3 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 flex items-center justify-center space-x-2 text-sm"
      >
        <i class="fas fa-edit text-xs"></i>
        <span>MANAGE PROPERTIES</span>
      </button>
    </div>
  </div>
</div>
